export default __webpack_public_path__ + "static/media/en-fl.950d46de.jpg";